// extracted by mini-css-extract-plugin
export default {"search":"StudentsPhotosPage_search__3b+SG"};